export default __webpack_public_path__ + "images/LK.c8420c3.png";